<template>
  <div ref="box" class="lottie-preview"></div>
</template>

<script>
// 리소스 lottie를 컨테이너에 맞춰 재생하는 축소판 미리보기(스토어 배경 카드 등).
// TheBackgroundCanvas와 동일하게 lottie-web + resolveResourceUrl 사용.
import lottieWeb from "lottie-web";
import { resolveResourceUrl } from "@/constants";

export default {
  name: "LottiePreview",
  props: {
    fileName: { type: String, default: null },
    subfolder: { type: String, default: "lotties/background-canvas" },
  },
  watch: {
    fileName() {
      this.renderLottie();
    },
  },
  mounted() {
    this.renderLottie();
  },
  beforeDestroy() {
    if (this._anim) this._anim.destroy();
  },
  methods: {
    renderLottie() {
      if (this._anim) {
        this._anim.destroy();
        this._anim = null;
      }
      if (!this.fileName || !this.$refs.box) return;
      this._anim = lottieWeb.loadAnimation({
        container: this.$refs.box,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: resolveResourceUrl(this.fileName, this.subfolder),
        rendererSettings: { preserveAspectRatio: "xMidYMid slice" }, // contain(meet) → cover(slice)
      });
    },
  },
};
</script>

<style scoped>
.lottie-preview {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
